import LocalAttachmentsService from "@mirage/services/LocalAttachmentsService";
import { List, ListItemButton, ListSubheader, Skeleton, Typography } from "@mui/material";
import { IAttachment } from "@shared/mirage/core/contracts/IAttachment";
import { memo, useEffect, useMemo, useState } from "react";

export interface SupersedingDialogProps {
    candidate:  IAttachment | null;
    supersedingAttachment: IAttachment ;
    publicOnly: boolean;
    entityName: string;
    recordId: number;
    onSupersedeCandidateClicked: (attachment: IAttachment) => void;

}


export const SupersedingDialog =  memo((props:SupersedingDialogProps)=>{
    const { candidate, supersedingAttachment, publicOnly, entityName, recordId, onSupersedeCandidateClicked } = props;
    const service = useMemo(() => new LocalAttachmentsService(publicOnly), [publicOnly]);
    const [loading, setLoading] = useState(false);
    const [allAttachments, setAllAttachments] = useState<IAttachment[]>([]);
    const candidates = allAttachments.filter((r) => r.id !== supersedingAttachment.id && !r.sourceId);
        const candidateList = candidates.map((c) => {
            return (
                <ListItemButton
                key={c.id}
                selected={c.id === candidate?.id}               
                    onClick={() => {
                        onSupersedeCandidateClicked(c);
                        setAllAttachments(allAttachments.map((a) => ({ ...a, selected: a.id === c.id })));
                    }}
                     >
                    {c.name}
                </ListItemButton>
            );
        });


    useEffect(()=>{
        const loadAttachments = async () => {
            setLoading(true);
            const allAttachments = await service.GetAttachments(entityName, recordId);
            setAllAttachments(allAttachments);
            setLoading(false);
        };
        loadAttachments();
    },[entityName, recordId, service]);

    return (
        <>
            <List
                className="documentsTable__supersedeList"
                sx={{
                    "& ul": { padding: 0 },
                }}
            >
                <ListSubheader>
                    <Typography variant="h5">Existing attachments</Typography>
                </ListSubheader>
                <>
                    {loading ? (
                        <div>
                            <Skeleton variant="rectangular" sx={{ marginTop: "10px" }} />
                            <Skeleton variant="rectangular" sx={{ marginTop: "10px" }} />
                            <Skeleton variant="rectangular" sx={{ marginTop: "10px" }} />
                            <Skeleton variant="rectangular" sx={{ marginTop: "10px" }} />
                        </div>
                    ) : (
                        candidateList
                    )}
                </>
            </List>
        </>
    );
}) 